import React from "react";
import { Translation, t } from "../../../../core/translate";
import styled from "styled-components";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";
import ExploreSearch from "./explore-search";

const Styled = {
  SearchSection: styled.div`
    align-items: center;
    background-color: ${props => props.theme.color.base.getShade(8)};
    display: flex;
    flex-direction: column;
    padding: 43px 47px 57px 47px;
    margin-bottom: 48px;

    ${styledMedia.medium`
    margin-bottom: 35px;
  `}

    ${styledMedia.small`
    margin-bottom: 21px;
    padding: 38px 26px 17px 26px;
  `}
  `,
  SearchText: styled.h2`
    color: white;
    font-size: 3rem;
    font-weight: 500;
    margin-bottom: 30px;
    width: 100%;
    text-align: center;

    ${styledMedia.medium`
      font-size: 2.7rem;
    `}

    ${styledMedia.small`
      font-size: 1.8rem;
      margin-bottom: 22px;
    `}
  `,
  SearchContainer: styled.div`
    margin: 0 auto;
  `
};

export default () => {
  return (
    <Styled.SearchSection>
      <Styled.SearchText>
        <Translation id="explore.looking-specific">
          Looking for something specific?
        </Translation>
      </Styled.SearchText>
      <Styled.SearchContainer>
        <ExploreSearch />
      </Styled.SearchContainer>
    </Styled.SearchSection>
  );
};
